import Base from '@studiometa/js-toolkit';

/**
 * Homepage class.
 */
export default class Search extends Base {
  /**
   * Class cofnig
   * @type {Object}
   */
  static config = {
    name: 'Serch',
    refs: ['open', 'close', 'block'],
  };

  /**
   * Log a nice message when app is ready.
   *
   * @return {void}
   */
  mounted() {}

  /**
   * Click trigger open search
   * @param {Event} e
   */
  onOpenClick(e) {
    e.preventDefault();

    this.$refs.block.classList.remove('m:-translate-y-full');

    const input = this.$refs.block.querySelector('input');
    if (input) input.focus();
  }

  /**
   * Click trigger close search
   * @param {Event} e
   */
  onCloseClick(e) {
    e.preventDefault();

    this.$refs.block.classList.add('m:-translate-y-full');
  }
}
